const t = "Press Tab to go to popover", o = {
  triggerHint: t
};
export {
  o as default,
  t as triggerHint
};
